export const selectFirstParagraph = (phrase) => {
  if (phrase === undefined) return undefined;

  return phrase.split('\n')[0].trim();
};

export const selectAccreditation = (phrase) => {
  if (phrase === undefined) {
    return {
      quoteName: undefined,
      quoteJobTitle: undefined,
    };
  }

  // Match the first comma, not inside brackets
  const match = phrase.match(/,(?![^(]*\)) /u);

  if (match === null) {
    return {
      quoteName: phrase,
      quoteJobTitle: undefined,
    };
  }

  return {
    quoteName: phrase.slice(0, match.index),
    quoteJobTitle: phrase.slice(match.index + 1).trim(),
  };
};
